module.exports = __webpack_public_path__ + "img/m_b.9e3217fb.png";